import React, { useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import {
  Box,
  Container,
  Typography,
  Button,
  Paper,
  IconButton,
} from '@mui/material';
import { ArrowBack as ArrowBackIcon } from '@mui/icons-material';
import html2canvas from 'html2canvas';

function PreviewPage() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();
  const result = location.state?.result;
  const cardRef = useRef(null);

  if (!result) {
    navigate('/');
    return null;
  }

  const handleSave = async () => {
    if (cardRef.current) {
      const canvas = await html2canvas(cardRef.current);
      const link = document.createElement('a');
      link.download = `chinese-name-${result.chinese_name}.png`;
      link.href = canvas.toDataURL('image/png');
      link.click();
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#fafafa', pt: 2 }}>
      <Container maxWidth="sm">
        <IconButton
          onClick={() => navigate(-1)}
          sx={{ mb: 2 }}
          color="primary"
        >
          <ArrowBackIcon />
        </IconButton>

        <Paper
          ref={cardRef}
          elevation={3}
          sx={{
            p: 4,
            borderRadius: 2,
            background: 'linear-gradient(145deg, #ffffff 0%, #f8f8f8 100%)',
          }}
        >
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <Typography variant="h3" align="center">
              {result.chinese_name}
            </Typography>
            <Typography variant="h5" align="center" color="text.secondary">
              {result.pinyin}
            </Typography>
            
            <Box sx={{ 
              mt: 2,
              p: 2,
              borderRadius: 2,
              bgcolor: 'rgba(255, 36, 66, 0.05)',
            }}>
              <Typography variant="body1" paragraph>
                {result[`explanation_${i18n.language}`]}
              </Typography>
              <Typography variant="body1">
                {result.explanation_zh}
              </Typography>
            </Box>

            <Typography
              variant="caption"
              align="right"
              sx={{ mt: 2, color: 'text.secondary' }}
            >
              Generated by Cultural Chinese Name Generator
            </Typography>
          </Box>
        </Paper>

        <Box sx={{ mt: 3, mb: 4 }}>
          <Button
            fullWidth
            variant="contained"
            color="primary"
            onClick={handleSave}
            size="large"
          >
            {t('saveImage')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
}

export default PreviewPage;
